export enum OnboardingType {
  Onboarder = 1,
  Self = 2,
}

export enum CustomerStatus {
  InService = 'in service',
}

export enum ContractTypeId {
  Upgrade = 23,
  Renewal = 24,
}

export const LineItemCategory = {
  PhonePurchase: 'phone purchase',
  FreePhones: 'free phones',
  RentalPhones: 'rental phones',
  AdditionalFeatures: 'additional features',
  CallPathModel: 'call path model',
  HostedPbxPlans: 'hosted pbx plans',
  CallingPlan: 'calling plan',
  CallingPlans: 'calling plans',
  LegacyCallingPlan: 'legacy calling plan',
  SipTrunkingModel: 'sip trunking model',
  NumberPorting: 'number porting',
  Net2phoneAi: 'net2phone ai',
  Net2phoneCoach: 'net2phone coach',
};

export const EquipmentCategories = [LineItemCategory.PhonePurchase, LineItemCategory.FreePhones, LineItemCategory.RentalPhones];

export interface IQuote {
  id: number;
  html: string;
  onboardingType: OnboardingType | null;
  customer: IQuoteCustomer;
  parentCustomer?: IQuoteCustomer;
  shipping: IQuoteShipping;
  promo: IQuotePromo;
  totals: IQuoteTotals;
  items: IQuoteItem[];
  contractTypeId: number;
  hasNoAdditions: boolean;
  aiTermsUrl: string;
  coterminousContractEndDate: Date | null;
}

export interface IQuoteCustomer {
  name: string;
  demoCustomer: boolean;
  contactCustomer?: boolean;
  contactPartner?: boolean;
  status?: string;
  billingStatus?: string;
  customerTaxId?: string;
  childrenInService?: boolean;
  alternatePayment?: boolean;
  language?: string;
  customerDelegates: ICustomerDelegate[];
  contacts: IQuoteContact[];
  address: IQuoteAddress;
}

export interface IQuoteContact {
  fname: string;
  lname: string;
  email: string;
  phone: string;
}

export interface IQuoteAddress {
  line1: string;
  line2: string;
  line3: string;
  city: string;
  state: string;
  country: string;
  zip: string;
  neighborhood: string;
  streetNumber: string;
  recipient?: string;
}

export interface ICustomerDelegate {
  id: number;
  status: string;
  name: string;
  email: string;
}

export interface IQuoteShipping {
  cost: number;
  shippingOption: string;
  address: IQuoteAddress;
  contact: IQuoteContact;
}

export interface IQuotePromo {
  code: string;
  duration: number;
}

export interface IQuoteTotals {
  nrc: number;
  mrc: number;
  promoMrc: number;
  upgradeMrc: number;
}

export interface IQuoteItem {
  qty: number;
  lineitem: IQuoteLineItem;
}

export interface IQuoteLineItem {
  category: string;
  hardwaremfg: string;
  hardwaresku: string;
  template: boolean;
}

export interface IAcceptQuoteRequest {
  quoteShortCode: string;
  customerContactEmail: string;
  customerContactFirstName: string;
  customerContactLastName: string;
  ccToken: string;
  ccCardHolder: string;
  payCardType: string;
  paymentMethod: string;
  debitBankName: string;
  debitAccountCode: string;
  customerInformation?: ICustomerInformation;
  signerSignatoryPosition: string;
  signerNationalId: string;
  customerStateTaxId: string;
  shipmentOption: string;
  estimatedShippingCharges?: number;
  shippingContact?: IPartnerContact;
  technicalContacts: IPartnerContact[];
  targetInstallDate: string;
  targetPortDate: string;
  payShipFirstName: string;
  payShipLastName: string;
  invoiceDueDay: string;
  signerFirstName: string;
  signerLastName: string;
  invoiceAnalysisContactEmail: string;
  invoiceAnalysisContactPhone: string;
  onboardingType?: OnboardingType | null;
  adminFirstName?: string;
  adminLastName?: string;
  adminEmail?: string;
  aiTermsOfServiceAcceptanceDate?: Date;
  isEquipmentOrder: boolean;
  serviceShortAddress1?: string;
  serviceInputAddress1?: string;
  serviceSelectedAddress1?: string;
  tenantLanguage: string;
  language: string;
  timezone: string;
  hasNoAdditions: boolean;
  coterminousTermsOfServiceAcceptanceDate?: Date;
  shippingTimeRestriction: string;
}

export interface ICustomerInformation {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  companyName: string;
  taxId: string;
  customerAddress: ICompanyAddress;
  shippingAddress: ICompanyAddress;
  serviceAddress: ICompanyAddress | null;
  contact1: ICustomerContact;
  contact2?: ICustomerContact;
  contact3?: ICustomerContact;
  delegates: IDelegateModel[];
}

export interface IPartnerContact {
  firstName: string;
  lastName: string;
  email: string;
  phone?: string;
}

export interface IDelegateModel {
  id: number;
  status: string;
  email: string;
  name: string;
}

export interface ICustomerContact extends IPartnerContact {
  companyName?: string;
  phoneNumber: string;
}

export interface ICompanyAddress {
  address1: string;
  address2: string;
  address3: string;
  city: string;
  state: string;
  stateAbbreviation: string;
  country: string;
  countryAbbreviation: string;
  zipCode: string;
  neighborhood: string;
  streetNumber: string;
  recipient: string;
}

export interface IAcceptQuoteResponse {
  onboardingType: OnboardingType;
}
